import React, { Fragment } from 'react';
import { ListItemButton, Typography, Collapse, Tooltip, InputLabel, FormControl, MenuItem, Stack, Alert, Select } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from "./Widgets/CustomToolbar";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import SuccessError from "./Widgets/SuccessError";
import Paper from '@mui/material/Paper';
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import _without from "lodash/without";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import RadioGroup from '@mui/material/RadioGroup';
import SelfSizingTextField from './Widgets/selfSizingTextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';

import { Controller } from "react-hook-form";
import { set } from 'date-fns';
import { de } from 'date-fns/locale';
import { sys } from 'typescript';
import { data } from 'jquery';
import { max } from 'lodash';
var refreshData = 1;
const DataSystems = () => {
    const [editOpen, setEditOpen] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [deleteName, setDeleteName] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);
    const [generalOpen, setGeneralOpen] = useState(true);
    const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
    const [accessToken, setAccessToken] = useState();
    const [refreshGrid, setRefreshGrid] = useState(0);
    const [departmentsSelected, setDepartmentsSelected] = useState([]);
    const [adminAccessSelected, setAdminAccessSelected] = useState([]);
    const [dataTypesSelected, setDataTypesSelected] = useState([]);
    const [sourcesSelected, setSourcesSelected] = useState([]);
    const [riskLevel, setRiskLevel] = useState('0');
    const [riskText, setRiskText] = useState('');
    const [isAdding, setIsAdding] = React.useState(false);
    const [dataSystemType, setDataSystemType] = useState('0');
    const [usersWithVeryHighRiskSelected, setUsersWithVeryHighRiskSelected] = useState([]);
    const [usersWithHighRiskSelected, setUsersWithHighRiskSelected] = useState([]);
    const [usersWithModerateRiskSelected, setUsersWithModerateRiskSelected] = useState([]);
    const [usersWithLowRiskSelected, setUsersWithLowRiskSelected] = useState([]);
    const [usersWithMinimalRiskSelected, setUsersWithMinimalRiskSelected] = useState([]);

    const x = refreshData;
    const handleDepartmentsChange = (event) => {
        const {
            target: { value },
        } = event;
        setDepartmentsSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleAdminAccessChange = (event) => {
        const {
            target: { value },
        } = event;
        setAdminAccessSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleUsersWithVeryHighRiskChange = (event) => {
        const {
            target: { value },
        } = event;
        setUsersWithVeryHighRiskSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForUsersWithVeryHighRisk = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };
    const handleUsersWithHighRiskChange = (event) => {
        const {
            target: { value },
        } = event;
        setUsersWithHighRiskSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForUsersWithHighRisk = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };
    const handleUsersWithModerateRiskChange = (event) => {
        const {
            target: { value },
        } = event;
        setUsersWithModerateRiskSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForUsersWithModerateRisk = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };
    const handleUsersWithLowRiskChange = (event) => {
        const {
            target: { value },
        } = event;
        setUsersWithLowRiskSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForUsersWithLowRisk = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };
    const handleUsersWithMinimalRiskChange = (event) => {
        const {
            target: { value },
        } = event;
        setUsersWithMinimalRiskSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForUsersWithMinimalRisk = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };
    const handleDataTypesChange = (event) => {
        const {
            target: { value },
        } = event;
        setDataTypesSelected(typeof value === 'string' ? value.split(',') : value,);
        var selectedDataTypes = typeof value === 'string' ? value.split(',') : value;
        var riskLevel = calculateRiskLevel(selectedDataTypes);
    };
    const calculateRiskLevel = (selectedDataTypes) => {
        //calculate risk level based on data types selected using the maximum risk level of any data type selected
        var maxRiskLevel = 0;

        selectedDataTypes.forEach(dataType => {
            //Very high risk data types
            if (dataType === 'Biometric Data' || dataType === 'Employee - Health information' || dataType === 'Student - Health' || dataType === 'Student - Safeguarding/Child Protection Records' || dataType === 'Student - Support') {
                maxRiskLevel = 4;
                setRiskLevel(4);
                return;
            }
            //High risk data types
            else if (dataType === 'Employee - Emergency Contact Information' || dataType === 'Employee - HR Records' || dataType === 'Employee - Payroll' || dataType === 'Parent - Financial Information' || dataType === 'Student - Disciplinary Records' || dataType === 'Student - Socio-Economic' || dataType === 'Student - Support') {
                if (maxRiskLevel < 3) {
                    maxRiskLevel = 3;
                }
            }
            //Moderate risk data types
            else if (dataType === 'Employee - Cloud Drive Storage ' || dataType === 'Employee - Performance Evaluation' || dataType === 'Student - Achievement' || dataType === 'Student - Admissions' || dataType === 'Student - Attendance' || dataType === 'Student - Behaviour' || dataType === 'Student - Cloud Drive Storage') {
                if (maxRiskLevel < 2) {
                    maxRiskLevel = 2;
                }
            }
            //low risk data types
            else if (dataType === 'Alumni - Demographic' || dataType === 'Employee - Demographic' || dataType === 'Employee - Email and Calendar' || dataType === 'Parent - Demographic' || dataType === 'Student - Demographic' || dataType === 'Student - Email and Calendar') {
                if (maxRiskLevel < 1) {
                    maxRiskLevel = 1;
                }
            }

        });
        setRiskLevel(maxRiskLevel);

    }
    const handleSourcesChange = (event) => {
        const {
            target: { value },
        } = event;
        setSourcesSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForApplicableDepts = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        // if (value === 'Other') {
        //   setotherDepartmentsShow(false);
        // }
    };
    const handleChipDeleteForDataTypes = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        // if (value === 'Other') {
        //   setotherDepartmentsShow(false);
        // }
    };
    const handleChipDeleteForAdminAccess = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        // if (value === 'Other') {
        //   setotherDepartmentsShow(false);
        // }
    };
    const handleChipDeleteForSources = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        // if (value === 'Other') {
        //   setotherDepartmentsShow(false);
        // }
    };
    const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
        '&.Mui-selected, &.Mui-selected:hover': {
            color: 'white',
            backgroundColor: selectedColor,
        },
    }));
    const handleRiskLevelChange = (event, newValue) => {

        setRiskLevel(newValue);
    };
    const handleRiskText = function (newValue) {

        setRiskText(newValue);
    };
    const useAsyncLoad = (url) => {
        const [errorA, setErrorA] = useState(null);
        const [loading, setLoading] = useState(true);
        const [dataSystems, setDataSystems] = useState(null);
        const { getAccessTokenSilently } = useAuth0();

        async function GetDataSystemsData(url) {

            const audience = 'https://piaapplication.azurewebsites.net/';

            // const accessToken = await getAccessTokenSilently({
            //     audience: audience,

            // });


            // var bearer = 'Bearer ' + accessToken;

            const accessToken = localStorage.getItem("userToken");

            var datasystemsData = await fetch(url, {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': accessToken,
                    'Content-Type': 'application/json'
                }
            });

            var data = await datasystemsData.json();

            data.accessToken = accessToken;
            setAccessToken(accessToken);

            return data;

        };


        async function loadData(url) {

            try {

                setErrorA(null);
                //setLoading(true);
                var data = await GetDataSystemsData(url);

                setDataSystems(data);
                //console.log(data);

            } catch (e) {

                setLoading(false);
                setErrorOpen(true);
            } finally {

                setLoading(false);
            }
        }

        useEffect(() => {
            loadData(url);
        }, [refreshData]);

        return [dataSystems, errorA, loading];
    }


    const FetchDataSystems = () => {
        const [value, error, loading] = useAsyncLoad("datasystems/getDataSystems");

        return [value, error, loading];
    }


    var returnData = FetchDataSystems();
    //console.log(returnData);
    if (returnData[0] !== null) {
        var dataSystemsData = returnData[0].dataSystems;


    }
    //console.log(dataSystemsData);

    var loading = returnData[2];
    var error = returnData[1];

    var departmentItems = [];
    var dataTypesItems = [];
    var sourceItems = [];
    var vendorsToDisplay = [];
    var adminAccessItems = [];
    var pias = [];
    var systemOwners = [];
    var dataUsersList = [];
    if (returnData[0] !== null) {
        //console.log(returnData[0]);
        departmentItems = returnData[0].departmentsList;
        dataTypesItems = returnData[0].dataTypeList;
        sourceItems = returnData[0].sourceList;
        vendorsToDisplay = returnData[0].vendorNames;
        pias = returnData[0].pias;
        systemOwners = returnData[0].dataUsersList;
        adminAccessItems = returnData[0].dataUsersList.map(user => user.firstName + " " + user.lastname);
        dataUsersList = returnData[0].dataUsersList.map(user => user.firstName + " " + user.lastname);
    }

    const closeSuccess = () => {
        setSuccessOpen(false);
    };
    const closeError = () => {
        setErrorOpen(false);
    };

    const handleCancel = () => {
        setEditOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // const CustomDisableInputSelect = styled(Select)(() => ({
    //     ".MuiInputBase-input.Mui-disabled": {
    //       WebkitTextFillColor: "#888",
    //       color: "#888"
    //     }
    //   }));

    const validationSchema = Yup.object().shape({
        id: Yup.number()
            .required('Vendor is required'),

        vendorId: Yup.number()
            .required('Vendor is required')
            .positive('Vendor is required'),
        module: Yup.string()
            .max(500, 'Module must not exceed 500 characters'),
        notes: Yup.string()
            .max(2000, 'Notes must not exceed 2000 characters'),
        systemName: Yup.string()
            .required('System Name is required')
            .max(500, 'System Name must not exceed 500 characters'),
        systemDescription: Yup.string()
            .required('System Description is required')
            .max(1000, 'System Description must not exceed 1000 characters'),
        contact: Yup.string()
            .max(250, 'Contact Names must not exceed 250 characters'),
        source: Yup.string()
            .required('Privacy Office info is required')
            .max(500, 'Privacy Office info must not exceed 350 characters'),

        // url: Yup.string()
        //   .required('URL is required')
        //   .matches(UrlRe, 'URL is not valid')
        //   .max(500, 'URL must not exceed 350 characters'),
        source: Yup.string()
            //.required('Privacy Office info is required')
            .max(500, 'Source info must not exceed 500 characters'),
        tenantPiaId: Yup.number(),
        systemOwnerId: Yup.number(),


        // privacyPolicyUrl: Yup.string()
        //   .matches(UrlRe, 'URL is not valid')
        //   .max(500, 'URL must not exceed 350 characters')
        //   .nullable(),

    });
    const {
        register,
        control,
        setValue,
        getValues,
        handleSubmit,
        clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const showSuccess = message => {
        setSuccessOpen(true);
        setSuccessMessage(message);
        setTimeout(() => setSuccessOpen(false), 3000);
    };

    const showError = message => {
        setErrorOpen(true);
        setErrorMessage(message);
        setTimeout(() => setErrorOpen(false), 3000);
    };
    async function saveDataSystem(dataSystem, saveOrAddOrDelete, accessToken) {

        var method = '';
        var url = ''
        if (saveOrAddOrDelete === 'Add') {
            method = 'POST';
            url = 'datasystems/';
        } else if (saveOrAddOrDelete === 'Save') {
            method = 'PUT';
            url = 'datasystems/' + dataSystem.id;
        }
        else if (saveOrAddOrDelete === 'Delete') {
            method = 'DELETE';
            url = 'datasystems/' + dataSystem.id;
        }

        dataSystem.riskLevel = riskLevel;
        dataSystem.selectedDepartments = departmentsSelected;
        dataSystem.adminAccessSelected = adminAccessSelected;
        dataSystem.selectedDataTypes = dataTypesSelected;
        var bearer = localStorage.getItem("userToken");

        try {
            const requestOptions = {
                method: method,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataSystem)
            };

            var result = await fetch(url, requestOptions);


            if (result.status === 500) {
                showError("Error saving Data System");
            } else if (result.status === 404) {
                showError("Error saving Data System");
            }

            else {
                switch (saveOrAddOrDelete) {
                    case 'Save':
                        showSuccess("Update Successful");
                        break;
                    case 'Add':
                        showSuccess("New record added successfully");
                        break;
                    case 'Delete':
                        showSuccess("Record Deleted");
                        break;
                    default:
                        showSuccess("Update Successful");

                }

            }
        } catch (e) {

            showError();
        } finally {
            //setRefreshGrid(refreshGrid + 1);
            refreshData = refreshData + 1;
            //console.log(reRender);
        }
    }

    const onSubmit = data => {

        if (data.id === -1) {
            saveDataSystem(data, 'Add', accessToken);
        } else {
            saveDataSystem(data, 'Save', accessToken);
        }
        setEditOpen(false);
    };
    //grid columns
    const columns = [
        {
            field: "Actions", width: 150, sortable: false,
            disableExport: 'true',
            renderCell: (cellValues) => {
                return (

                    <div>
                        {/* {vendorData.userAndTenant.isSuperAdmin && */}
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickOpen(event, cellValues, dataSystemsData.accessToken);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {/* } */}

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleDeleteOpen(event, cellValues);
                            }}
                        >
                            <DeleteIcon />
                        </Button>

                    </div>
                );
            }
        },
        {
            field: 'vendorName', headerName: 'Vendor', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.vendorName);

            }
        },
        // { field: 'phone', headerName: 'Phone', width: 130 },
        {
            field: 'systemName', headerName: 'System', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.systemName);

            }
        },
        {
            field: 'module', headerName: 'Module', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.module);

            }
        },
        {
            field: 'contact', headerName: 'Contact', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.contact);

            }
        },


        {
            field: 'riskLevelName', headerName: 'Risk Level', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                if (cellValues.row.riskLevelName.indexOf('None') > -1) {
                    return (<Typography color={'white'} bgcolor={'green'}  >{cellValues.row.riskLevelName}</Typography>)
                }
                else if (cellValues.row.riskLevelName.indexOf('Low') > -1) {
                    return (<Typography color={'black'} bgcolor={'yellow'}  >{cellValues.row.riskLevelName}</Typography>)
                }
                else if (cellValues.row.riskLevelName.indexOf('Medium') > -1) {
                    return (<Typography color={'white'} bgcolor={'orange'}  >{cellValues.row.riskLevelName}</Typography>)
                }
                else if (cellValues.row.riskLevelName.indexOf('High') > -1) {
                    return (<Typography color={'white'} bgcolor={'red'}  >{cellValues.row.riskLevelName}</Typography>)
                }
                else return (<Typography>not specified</Typography>)
            }
        },
        {
            field: 'tenantPiaId', headerName: 'PIA Complete', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                if (cellValues.row.tenantPiaId > 0) {
                    var url = '/apps/' + cellValues.row.tenantPiaId;
                    return (<a href={url}>Link to PIA</a>)
                    //return "(<a href='\app\"+"{cellValues.row.tenantPiaId}'>Link to PIA</a>)
                }
                // else if (cellValues.row.riskLevelName.indexOf('Low') > -1) {
                //     return (<Typography bgcolor={'yellow'}  >{cellValues.row.riskLevelName}</Typography>)
                // }
                // else if (cellValues.row.riskLevelName.indexOf('Medium') > -1) {
                //     return (<Typography bgcolor={'orange'}  >{cellValues.row.riskLevelName}</Typography>)
                // }
                // else if (cellValues.row.riskLevelName.indexOf('High') > -1) {
                //     return (<Typography bgcolor={'red'}  >{cellValues.row.riskLevelName}</Typography>)
                // }
                else return (<Typography>Not Complete</Typography>)
            }
        }

    ];

    const handleClickOpen = (event, cellValues, accessToken) => {

        var dataRow = cellValues.row;
        setValue("id", dataRow.id);

        setValue("systemName", dataRow.systemName);
        setValue("module", dataRow.module);
        setValue("contact", dataRow.contact);
        setValue("adminAccess", dataRow.adminAccess);
        setValue("source", dataRow.source);
        setValue("vendorId", dataRow.vendorId);
        setValue("tenantPiaId", dataRow.tenantPiaId);
        setValue("notes", dataRow.notes);
        setValue("systemDescription", dataRow.systemDescription);
        if (dataRow.systemOwnerId) {
            setValue("systemOwnerId", dataRow.systemOwnerId);
        }
        setIsAdding(false);


        setRiskLevel(dataRow.riskLevel);

        setDepartmentsSelected(dataRow.selectedDepartments);
        if (dataRow.selectedDataTypes === null) {
            setDataTypesSelected([]);
        } else {
            setDataTypesSelected(dataRow.selectedDataTypes);
        }
        setEditOpen(true);

    };
    const handleDeleteOpen = (event, cellValues) => {
        var dataRow = cellValues.row;
        setDeleteName(dataRow.module);
        setDeleteId(dataRow.id)
        setDeleteOpen(true);
    };

    const handleDelete = () => {
        var data = { id: deleteId };
        // data.id = deleteId;
        //saveVendor(data, 'Delete');
        saveDataSystem(data, 'Delete', accessToken);
        //reRender = reRender + 1;
        setDeleteOpen(false);
    };
    const addDataSystem = (event, cellValues) => {

        setValue("id", -1);
        setValue("module", '');
        setValue("systemName", '');
        setValue("systemDescription", '');
        setValue("contact", '');
        setValue("adminAccess", '');
        setValue("source", '');
        setValue("vendorId", 0);
        setValue("tenantPiaId", 0);
        setDepartmentsSelected([]);
        setDataTypesSelected([]);
        clearErrors();
        setEditOpen(true);
        setIsAdding(true);

    };
    const titleBoxBackgroundColour = '#1976d21a';

    if (loading) {
        return (
            // <div>
            //   Loading...
            // </div>

            <DarkBackground >
                <LoadingOverlay
                    active={true}

                    spinner={true}
                    text="Loading..."
                >
                </LoadingOverlay>
            </DarkBackground>

        )
    }
    return (

        <div>
            <SuccessError
                successMessage={successMessage}
                errorMessage={errorMessage}
                closeError={() => closeError()}
                closeSuccess={() => closeSuccess()}
                successOpen={successOpen}
                errorOpen={errorOpen}
            >
            </SuccessError>

            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h3" component="h2">
                    Data Systems
                </Typography>

                <Button variant="outlined" onClick={addDataSystem}>Add Data System</Button>
            </Box>
            <div style={{ height: '70vh', width: '100%' }}>
                <DataGrid

                    fullWidth

                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    initialState={{
                        pagination: {
                            pageSize: 1000,
                        },
                    }}
                    height='100%'
                    rows={dataSystemsData}
                    columns={columns}
                    //pageSize={100}
                    rowsPerPageOptions={[50, 100]}
                //checkboxSelection
                />

            </div>
            <Dialog open={editOpen} onClose={handleCancel}
                fullWidth

                maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '70%'
                    }
                }}

            >
                <DialogTitle>

                    <Box
                        component="span"
                        m={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        // border={3}
                        sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}
                    >
                        {editOrAddTitle} Data System

                    </Box>

                </DialogTitle>

                <DialogContent>
                    <form>
                        <Fragment>
                            <Paper variant="outlined" >
                                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                    onClick={() => setGeneralOpen(!generalOpen)}
                                >
                                    <Grid container sx={{ justifyContent: "space-between" }} >
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            Data System Information
                                        </Typography>
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                        </Typography>

                                    </Grid>
                                </Box>


                                <Collapse in={generalOpen} width={'100%'}>
                                    <Box sx={{ border: 1 }} px={1} py={2}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 10, paddingBottom: 10 }}>
                                                Select the option that best describes how this data is organized and stored within the school.
                                            </Grid>
                                            <Grid item xs={8} sm={8} md={8} style={{ paddingLeft: 10 }}>
                                                <FormControl>
                                                    <FormLabel id="data-system-type-label"> </FormLabel>
                                                    <RadioGroup

                                                        aria-labelledby="data-system-type-label"
                                                        defaultValue="0"
                                                        name="dataSystemType"
                                                        onChange={(e) => {

                                                            setDataSystemType(e.target.value);

                                                        }}
                                                    >
                                                        <Tooltip
                                                            title={
                                                                <p style={{ fontSize: '15px', margin: '0', padding: '0' }}>
                                                                    Data stored in a formal system with defined fields and controls; e.g., SIS, LMS, HR systems where information is consistently organized and managed
                                                                </p>
                                                            }
                                                            placement="right">
                                                            <FormControlLabel disabled={!isAdding} value="0" control={<Radio />} label="Structured System (Database/System of Record)" />
                                                        </Tooltip>
                                                        <Tooltip
                                                            title={
                                                                <p style={{ fontSize: '15px', margin: '0', padding: '0' }}>
                                                                    Physical records organized in a consistent, searchable way; e.g., filing cabinets or folders containing student, HR, or admissions files
                                                                </p>
                                                            }
                                                            placement="right">
                                                            <FormControlLabel disabled={!isAdding} value="1" control={<Radio />} label="Structured Filing System (Organized Paper Records)" />
                                                        </Tooltip>
                                                        <Tooltip
                                                            title={
                                                                <p style={{ fontSize: '15px', margin: '0', padding: '0' }}>
                                                                    Data stored in shared or personal digital spaces with some organization but less control; e.g., Google Drive folders, email inboxes, network drives
                                                                </p>
                                                            }
                                                            placement="right">
                                                            <FormControlLabel disabled={!isAdding} value="2" control={<Radio />} label="Semi-Structured (Drives, Email, Shared Folders)" />
                                                        </Tooltip>
                                                        <Tooltip
                                                            title={
                                                                <p style={{ fontSize: '15px', margin: '0', padding: '0' }}>
                                                                    Data stored informally without consistent structure or oversight; e.g., spreadsheets, notes, downloads, or files saved on devices
                                                                </p>
                                                            }
                                                            placement="right">

                                                            <FormControlLabel disabled={!isAdding} value="3" control={<Radio />} label="Unstructured (Ad hoc files, notes, exports)" />
                                                        </Tooltip>
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>



                                            {/* <Collapse in={dataSystemType === '0'} width={'100%'}> */}
                                            {(dataSystemType === '0' || dataSystemType === '2') && (
                                                <Fragment>
                                                <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 0, paddingTop: 10 }}>
                                                    <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 300 }}

                                                    >
                                                        <InputLabel>Data System from PIA</InputLabel>

                                                        <Controller

                                                            required
                                                            name="tenantPiaId"
                                                            control={control}
                                                            defaultValue=""
                                                            // {...register("vendor")}
                                                            render={({ field: { onChange, value } }) => (
                                                                <Select
                                                                    //disabled={!currentUser.isSuperAdmin && !isAdding}
                                                                    required
                                                                    defaultValue={0}
                                                                    value={value}
                                                                    label="Data System from PIA"

                                                                    onChange={(e) => {

                                                                        setValue('tenantPiaId', e.target.value, { shouldValidate: true });
                                                                        //find the pia that matches the selected id and set the system name to match the pia name 
                                                                        var selectedPia = pias.find(pia => pia.tenantPiaId === e.target.value);

                                                                        if (selectedPia) {
                                                                            setValue('systemDescription', selectedPia.description, { shouldValidate: true });
                                                                        }


                                                                    }}
                                                                >
                                                                    {pias.map((pia, index) => <MenuItem key={index} value={pia.tenantPiaId}>{pia.name}</MenuItem>)}

                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.tenantPiaId?.message}
                                                    </Typography>
                                                </Grid>
                                                </Fragment>
                                            )}
                                                {/* <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 10, paddingBottom: 10 }}>
                                                    Select the option that best describes how this data is organized and stored within the school.
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 10, paddingBottom: 10 }}>
                                                    Select the option that best describes how this data is organized and stored within the school.
                                                </Grid> */}
                                                <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 10, paddingTop: 10, minWidth: 750 }}>
                                                    {/* <TextField
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                        placeholder='Description of the software system. '
                                                        id="systemDescription"
                                                        name="systemDescription"
                                                        label="System Description"
                                                        fullWidth
                                                        margin="dense"
                                                        {...register('systemDescription')}
                                                        error={errors.systemDescription ? true : false}
                                                    />
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.systemDescription?.message}
                                                    </Typography> */}

                                                    <SelfSizingTextField
                                                        // disabled={!currentUser.isSuperAdmin}
                                                        initialValue={getValues('systemDescription')}
                                                        errors={errors.systemDescription}
                                                        register={register}
                                                        maxSize={1000}
                                                        name="systemDescription"
                                                        id="systemDescription"
                                                        label="System Description"
                                                        placeholder="System Description"
                                                    ></SelfSizingTextField>
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4} style={{ paddingLeft: 0, paddingTop: 10 }}>
                                                    <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 300 }}

                                                    >
                                                        <InputLabel>System Owner</InputLabel>

                                                        <Controller

                                                            required
                                                            name="systemOwnerId"
                                                            control={control}
                                                            defaultValue=""
                                                            // {...register("vendor")}
                                                            render={({ field: { onChange, value } }) => (
                                                                <Select
                                                                    //disabled={!currentUser.isSuperAdmin && !isAdding}
                                                                    required
                                                                    defaultValue={0}
                                                                    value={value}
                                                                    label="System Owner"

                                                                    onChange={(e) => {

                                                                        setValue('systemOwnerId', e.target.value, { shouldValidate: true });

                                                                    }}
                                                                >
                                                                    {systemOwners.map((owner, index) => <MenuItem key={index} value={owner.dataUserId}>{owner.firstName + " " + owner.lastname}</MenuItem>)}

                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.systemOwnerId?.message}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{ paddingLeft: 10, paddingTop: 10 }}>
                                                    <MultiSelectWithChips
                                                        label="Department Responsible"
                                                        name="departmentsSelected"
                                                        control={control}
                                                        value={departmentsSelected}
                                                        infoSelected={departmentsSelected}
                                                        //infoNASelected={studentInfoNASelected}
                                                        setinfoSelected={setDepartmentsSelected}
                                                        onChange={handleDepartmentsChange}
                                                        handleChipDelete={handleChipDeleteForApplicableDepts}
                                                        errors={errors.departmentItems}

                                                        items={departmentItems}
                                                    >
                                                    </MultiSelectWithChips>


                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.departmentsSelected?.message}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5} sm={5} style={{ paddingLeft: 10, paddingTop: 10 }}>
                                                    <MultiSelectWithChips
                                                        label="Admin Access"
                                                        name="adminAccessSelected"
                                                        control={control}
                                                        value={adminAccessSelected}
                                                        infoSelected={adminAccessSelected}
                                                        //infoNASelected={studentInfoNASelected}
                                                        setinfoSelected={setAdminAccessSelected}
                                                        onChange={handleAdminAccessChange}
                                                        handleChipDelete={handleChipDeleteForAdminAccess}
                                                        errors={errors.adminAccessItems}

                                                        items={adminAccessItems}
                                                    >
                                                    </MultiSelectWithChips>


                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.adminAccessSelected?.message}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5} sm={5} style={{ paddingLeft: 10, paddingTop: 10 }}>
                                                    <MultiSelectWithChips
                                                        label="Data Types"
                                                        name="dataTypesSelected"
                                                        control={control}
                                                        value={dataTypesSelected}
                                                        infoSelected={dataTypesSelected}
                                                        //infoNASelected={studentInfoNASelected}
                                                        setinfoSelected={setDataTypesSelected}
                                                        onChange={handleDataTypesChange}
                                                        handleChipDelete={handleChipDeleteForDataTypes}
                                                        errors={errors.dataTypes}

                                                        items={dataTypesItems}
                                                    >
                                                    </MultiSelectWithChips>


                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.departmentsSelected?.message}
                                                    </Typography>
                                                </Grid>
                                                {(dataSystemType === '0' || dataSystemType === '2') && (
                                                    <Fragment>
                                                        <Grid item xs={5} sm={5} style={{ paddingLeft: 10, paddingTop: 10 }}>
                                                            <MultiSelectWithChips
                                                                label="Source"
                                                                name="sourceSelected"
                                                                control={control}
                                                                value={sourcesSelected}
                                                                infoSelected={sourcesSelected}
                                                                //infoNASelected={studentInfoNASelected}
                                                                setinfoSelected={setSourcesSelected}
                                                                onChange={handleSourcesChange}
                                                                handleChipDelete={handleChipDeleteForSources}
                                                                errors={errors.source}

                                                                items={sourceItems}
                                                            >
                                                            </MultiSelectWithChips>


                                                            <Typography variant="inherit" color="error.main">
                                                                {errors.departmentsSelected?.message}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} style={{ paddingLeft: 10, paddingTop: 10, minWidth: 900 }}   >
                                                            {/* <Typography>{riskText}</Typography> */}
                                                        </Grid>
                                                    </Fragment>
                                                )}

                                                {/* <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                                <Tooltip title="What department(s) are using this software?">
                                                    <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                </Tooltip>
                                            </Grid> */}
                                                {/* <Grid item xs={12} sm={12} md={12}>
                                                   <Grid item xs={4} sm={4} md={4}>
                                                <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 300 }}
                                                    required
                                                >
                                                    <InputLabel>Vendor</InputLabel>

                                                    <Controller

                                                        required
                                                        name="vendorId"
                                                        control={control}
                                                        defaultValue=""
                                                        // {...register("vendor")}
                                                        render={({ field: { onChange, value } }) => (
                                                            <Select
                                                                //disabled={!currentUser.isSuperAdmin && !isAdding}
                                                                required
                                                                defaultValue={0}
                                                                value={value}
                                                                label="Vendor"
                                                                onChange={(e) => setValue('vendorId', e.target.value, { shouldValidate: true })}
                                                            >
                                                                {vendorsToDisplay.map((vendor, index) => <MenuItem key={index} value={vendor.id}>{vendor.name}</MenuItem>)}

                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.vendorId?.message}
                                                </Typography>
                                            </Grid>
                                                </Grid> */}

                                            {/* </Collapse> */}
                                            {/* <Collapse in={dataSystemType === '1'} width={'100%'}>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    1
                                                </Grid>
                                            </Collapse> */}
                                            <Collapse in={dataSystemType === '2'} width={'100%'}>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    2
                                                </Grid>
                                            </Collapse>
                                            <Collapse in={dataSystemType === '3'} width={'100%'}>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    3
                                                </Grid>
                                            </Collapse>
                                            <Grid item xs={12} sm={12} style={{ paddingLeft: 10, paddingTop: 10 }}   >
                                                <Typography>Risk Level</Typography>
                                            </Grid>
                                            <Grid item xs={10} sm={10} md={10} style={{ paddingLeft: 10, paddingTop: 10 }} >

                                                <FormControl>
                                                    {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-radio-buttons-group-label"

                                                        name="radio-buttons-group"

                                                    >
                                                        <ToggleButtonGroup value={riskLevel} exclusive onChange={handleRiskLevelChange}>
                                                            <ToggleButton value={0} selectedColor="grey" onMouseEnter={() => handleRiskText('None: This is data that is not disclosed to the public. It carries no risk if openly revealed to the public.')} >

                                                                <span>Minimal</span>

                                                            </ToggleButton>
                                                            <ToggleButton value={1} selectedColor="green" onMouseEnter={() => handleRiskText('None: This is data that’s disclosed to the public such as general details about the insititution. It carries no risk and is openly revealed to the public.')}>

                                                                <span> Low (disclosed)</span>


                                                            </ToggleButton>
                                                            <ToggleButton value={2} selectedColor="lightgreen" onMouseEnter={() => handleRiskText('Low: This data is known to most or all employees. If this data is revealed, it may have low or no impact on the institution')}>

                                                                <span> Moderate </span>

                                                            </ToggleButton>
                                                            <ToggleButton value={3} selectedColor="Orange" onMouseEnter={() => handleRiskText('Medium: This information is created for the internal use of the institution, and it’s not meant to be revealed. If revealed, it may have a moderate impact on the institution.')}>

                                                                <span> High </span>

                                                            </ToggleButton>
                                                            <ToggleButton value={4} selectedColor="Red" onMouseEnter={() => handleRiskText('High: This is the most confidential data and revealing it can lead to huge financial or reputational losses to the institution.')}>

                                                                <span> Very High (Special Category Data)</span>

                                                            </ToggleButton>

                                                        </ToggleButtonGroup>

                                                    </RadioGroup>
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.commonSense?.message}
                                                </Typography>

                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    required
                                                    id="id"
                                                    name="id"
                                                    label="ID"
                                                    fullWidth
                                                    hidden
                                                    margin="dense"
                                                    {...register('id')}

                                                />

                                            </Grid>


                                            {/* <Grid item xs={12} sm={12}>
                                                <TextField

                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='Describe the name of the module '
                                                    id="module"
                                                    name="module"
                                                    label="Module"
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('module')}
                                                    error={errors.module ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.module?.message}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Contact Names"
                                                    id="contact"
                                                    name="contact"
                                                    placeholder="The name(s) of the individual who is responsible for the data."
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('contact')}
                                                    error={errors.contact ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.contact?.message}
                                                </Typography>
                                            </Grid> */}

                                            {/* <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Department"
                                                    name="departmentsSelected"
                                                    control={control}
                                                    value={departmentsSelected}
                                                    infoSelected={departmentsSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setDepartmentsSelected}
                                                    onChange={handleDepartmentsChange}
                                                    handleChipDelete={handleChipDeleteForApplicableDepts}
                                                    errors={errors.departmentItems}

                                                    items={departmentItems}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.departmentsSelected?.message}
                                                </Typography>
                                            </Grid> */}


                                            {/* <Grid item xs={12} sm={12}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Privacy Names of tech administrators who also have access to the data."
                                                    id="adminAccess"
                                                    name="adminAccess"
                                                    label="Admin Access"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('adminAccess')}
                                                    error={errors.adminAccess ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.adminAccess?.message}
                                                </Typography>
                                            </Grid> */}
                                            {/* 
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="How is this data gathered?"
                                                    id="source"
                                                    name="source"
                                                    label="Source"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('source')}
                                                    error={errors.source ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.source?.message}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={2} sm={2} md={2}>
                                                <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 1 }}>Risk Level:</InputLabel>
                                            </Grid> */}




                                            <Grid item xs={12} sm={12}>
                                                <SelfSizingTextField
                                                    required
                                                    initialValue={getValues('notes')}
                                                    maxSize={2000}
                                                    errors={errors.description}
                                                    register={register}
                                                    name="notes"
                                                    id="notes"
                                                    label="Notes"
                                                    placeholder="Notes"

                                                ></SelfSizingTextField>
                                                {/* <TextField
                                                    rows={3}
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='Notes'
                                                    id="notes"
                                                    name="notes"
                                                    label="Notes"
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('notes')}
                                                    error={errors.notes ? true : false}
                                                /> */}
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.notes?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Users with Very High Risk/Special Category Data"
                                                    name="usersWithVeryHighRiskSelected"
                                                    control={control}
                                                    value={usersWithVeryHighRiskSelected}
                                                    infoSelected={usersWithVeryHighRiskSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setUsersWithVeryHighRiskSelected}
                                                    onChange={handleUsersWithVeryHighRiskChange}
                                                    handleChipDelete={handleChipDeleteForUsersWithVeryHighRisk}
                                                    errors={errors.usersWithVeryHighRiskSelected}

                                                    items={dataUsersList}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.usersWithVeryHighRiskSelected?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Users with High Risk"
                                                    name="usersWithHighRiskSelected"
                                                    control={control}
                                                    value={usersWithHighRiskSelected}
                                                    infoSelected={usersWithHighRiskSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setUsersWithHighRiskSelected}
                                                    onChange={handleUsersWithHighRiskChange}
                                                    handleChipDelete={handleChipDeleteForUsersWithHighRisk}
                                                    errors={errors.usersWithHighRiskSelected}

                                                    items={dataUsersList}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.usersWithVeryHighRiskSelected?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Users with Moderate Risk"
                                                    name="usersWithModerateRiskSelected"
                                                    control={control}
                                                    value={usersWithModerateRiskSelected}
                                                    infoSelected={usersWithModerateRiskSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setUsersWithModerateRiskSelected}
                                                    onChange={handleUsersWithModerateRiskChange}
                                                    handleChipDelete={handleChipDeleteForUsersWithModerateRisk}
                                                    errors={errors.usersWithModerateRiskSelected}

                                                    items={dataUsersList}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.usersWithModerateRiskSelected?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Users with Low Risk"
                                                    name="usersWithLowRiskSelected"
                                                    control={control}
                                                    value={usersWithLowRiskSelected}
                                                    infoSelected={usersWithLowRiskSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setUsersWithLowRiskSelected}
                                                    onChange={handleUsersWithLowRiskChange}
                                                    handleChipDelete={handleChipDeleteForUsersWithLowRisk}
                                                    errors={errors.usersWithLowRiskSelected}

                                                    items={dataUsersList}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.usersWithLowRiskSelected?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Users with Minimal Risk"
                                                    name="usersWithMinimalRiskSelected"
                                                    control={control}
                                                    value={usersWithMinimalRiskSelected}
                                                    infoSelected={usersWithMinimalRiskSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setUsersWithMinimalRiskSelected}
                                                    onChange={handleUsersWithMinimalRiskChange}
                                                    handleChipDelete={handleChipDeleteForUsersWithMinimalRisk}
                                                    errors={errors.usersWithMinimalRiskSelected}

                                                    items={dataUsersList}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.usersWithMinimalRiskSelected?.message}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Collapse>

                            </Paper>
                        </Fragment>
                    </form>
                </DialogContent>

                <DialogActions>
                    <Fragment>
                        <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>

                        <Button onClick={handleCancel}>Cancel</Button>
                    </Fragment>
                </DialogActions>


            </Dialog>

            <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Delete Data System</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you wish to Delete <strong>{deleteName} ?</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleDelete}>Delete</Button>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DataSystems;